{
  "v": "4.8.0",
  "meta": { "g": "LottieFiles AE 2.0.4", "a": "", "k": "", "d": "", "tc": "" },
  "fr": 60,
  "ip": 0,
  "op": 59,
  "w": 48,
  "h": 48,
  "nm": "OnlineKassa-Spinner",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Shape Layer 2",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [24, 24, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "d": 1,
          "ty": "el",
          "s": { "a": 0, "k": [40, 40], "ix": 2 },
          "p": { "a": 0, "k": [0, 0], "ix": 3 },
          "nm": "Ellipse Path 1",
          "mn": "ADBE Vector Shape - Ellipse",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.577], "y": [0] },
                "t": 10,
                "s": [0]
              },
              { "t": 60, "s": [100] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.536], "y": [0] },
                "t": 0,
                "s": [1]
              },
              { "t": 60, "s": [100] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [0.125, 0.129, 0.133, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 6, "ix": 5 },
          "lc": 2,
          "lj": 1,
          "ml": 1,
          "ml2": { "a": 0, "k": 1, "ix": 13 },
          "bm": 0,
          "nm": "Solid Stroke 1",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 90,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Shape Layer 1",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 24, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [24, 24, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "d": 1,
          "ty": "el",
          "s": { "a": 0, "k": [40, 40], "ix": 2 },
          "p": { "a": 0, "k": [0, 0], "ix": 3 },
          "nm": "Ellipse Path 1",
          "mn": "ADBE Vector Shape - Ellipse",
          "hd": false
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.648], "y": [0] },
                "t": 19,
                "s": [0]
              },
              { "t": 60, "s": [100] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0], "y": [1] },
                "o": { "x": [0.569], "y": [0] },
                "t": 0,
                "s": [1]
              },
              { "t": 60, "s": [100] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [0.125, 0.129, 0.133, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 6, "ix": 5 },
          "lc": 2,
          "lj": 1,
          "ml": 1,
          "ml2": { "a": 0, "k": 1, "ix": 13 },
          "bm": 0,
          "nm": "Solid Stroke 1",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 90,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
